import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 500, // 0.5 segundos
      staleTime: 5 * 60 * 1_000, // 5 minutos
      cacheTime: 5 * 60 * 1_000, // 5 minutos
    },
  },
});
